import { PlusIcon } from '@phosphor-icons/react';
import {
    Tooltip,
    TooltipContent,
    TooltipTrigger,
} from '@/components/ui/Tooltip';
import { cn } from '@/lib/utils';

interface AddFolderButtonProps {
    label: string;
    disabled?: boolean;
    onClick: () => void;
}

export function AddFolderButton({
    label,
    disabled,
    onClick,
}: AddFolderButtonProps) {
    return (
        <Tooltip>
            <TooltipTrigger asChild>
                <button
                    type="button"
                    aria-label={label}
                    disabled={disabled}
                    onClick={(event) => {
                        event.stopPropagation();
                        onClick();
                    }}
                    data-testid="folder-create-btn"
                    className={cn(
                        'hidden size-4 cursor-pointer items-center justify-center rounded text-grey-200 transition-colors hover:bg-grey-500 hover:text-white-100 group-hover:flex group-focus-within:flex focus-visible:flex',
                        'disabled:cursor-not-allowed disabled:opacity-60',
                    )}
                >
                    <PlusIcon className="size-3.5" weight="bold" />
                </button>
            </TooltipTrigger>
            <TooltipContent side="top" sideOffset={4}>
                {label}
            </TooltipContent>
        </Tooltip>
    );
}
